import { IConfig } from ".";

export default {
    env: "dev",
    api: "http://localhost:9999"
} as IConfig;